import {
  axiosInstance,
  CustomConfigEnum,
} from '@smart/util-web';
import { APPID } from '@/config';
import store from '../store';
import { setUserToken } from "@/global/tokenManager";

// function getRandomInRange(min, max) {
//   return Math.round(Math.random() * (max - min)) + min;
// }

// axiosInstance.defaults.headers.common.tags = 'dev';
export const userSilentLogin = async () => {
  const res = await axiosInstance.get('/hengxin/erp/api/client/biz/mine/user/touristLogin', {
    params: { appId: APPID }
  })
  if (res.data.isTouristOpen == 1) {
    store.commit('setLoginInfo', {
      hasLogin: false,
      isTouristOpen: res.data.isTouristOpen,
      isTouristDisplayPrice: res.data.isTouristDisplayPrice,
    })
    setUserToken(res.data.token);
  } else {
    store.commit('setLoginInfo', {
      hasLogin: false,
      isTouristOpen: 0,
      isTouristDisplayPrice: 0,
    })
    setUserToken('');
  }
};

export const axiosGet = (url, params, config) => axiosInstance.get(url, {
  params,
  ...config,
});

export const axiosPost = (url, params, config) => axiosInstance.post(url, params, config);

export default {

  // 三餐ajax
  get: (url, params, config) => axiosGet(url, params, {
    ...config,
    customConfig: CustomConfigEnum.DATA_REJECT | CustomConfigEnum.SHOW_LOADING | CustomConfigEnum.SHOW_MESSAGE,
  }),
  post: (url, params, config) => axiosPost(url, params, {
    ...config,
    customConfig: CustomConfigEnum.DATA_REJECT | CustomConfigEnum.SHOW_LOADING | CustomConfigEnum.SHOW_MESSAGE,
  }),

  // 不提示MESSAGE
  getNoMessage: (url, params, config = {}) => axiosGet(url, params, {
    ...config,
    customConfig: CustomConfigEnum.DATA_REJECT | CustomConfigEnum.SHOW_LOADING,
  }),
  postNoMessage: (url, params, config = {}) => axiosPost(url, params, {
    ...config,
    customConfig: CustomConfigEnum.DATA_REJECT | CustomConfigEnum.SHOW_LOADING,
  }),

  // 不提示MESSAGE, 不loading
  getNoTips: (url, params, config = {}) => axiosGet(url, params, {
    ...config,
    customConfig: CustomConfigEnum.DATA_REJECT,
  }),
  postNoTips: (url, params, config = {}) => axiosPost(url, params, {
    ...config,
    customConfig: CustomConfigEnum.DATA_REJECT,
  }),

  // 不Reject , 返回完整resp,
  getNoReject: (url, params, config = {}) => axiosGet(url, params, {
    ...config,
    customConfig: CustomConfigEnum.SHOW_LOADING | CustomConfigEnum.SHOW_MESSAGE,
  }),
  postNoReject: (url, params, config = {}) => axiosPost(url, params, {
    ...config,
    customConfig: CustomConfigEnum.SHOW_LOADING | CustomConfigEnum.SHOW_MESSAGE,
  }),

  // 不Reject , 返回完整resp 不loading 不 message,
  getNoRejectNoTips: (url, params, config = {}) => axiosGet(url, params, config),
  delete: (url, params, config = {}) => axiosInstance.delete(url, {
    params,
    ...config,
  }),
  postNoRejectNoTips: (url, params, config = {}) => axiosPost(url, params, config),
};
